import { Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/Home';
import RecommendedPage from './pages/Recommended';
import TopInfluencersPage from './pages/TopInfluencers';
import CreatorDetailPage from './pages/CreatorDetail';
import USCreatorsPage from './pages/USCreators';
import UKCreatorsPage from './pages/UKCreators';
import PolandCreatorsPage from './pages/PolandCreators';
import TripsPage from './pages/Trips';
import TripDetailPage from './pages/TripDetail';
import PrivacyPolicyPage from './pages/PrivacyPolicy';
import TermsConditionsPage from './pages/TermsConditions';
import AgeSuitabilityPage from './pages/AgeSuitability';
import AppAccessibilityPage from './pages/AppAccessibility';
import DSALabelsPage from './pages/DSALabels';
import RoadmapPage from './pages/Roadmap';
import PressReleasePage from './pages/PressRelease';
import ContactPage from './pages/Contact';

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/recommended" element={<RecommendedPage />} />
          <Route path="/recommended/top-influencers" element={<TopInfluencersPage />} />
          <Route path="/creator/:id" element={<CreatorDetailPage />} />
          <Route path="/recommended/us" element={<USCreatorsPage />} />
          <Route path="/recommended/uk" element={<UKCreatorsPage />} />
          <Route path="/recommended/poland" element={<PolandCreatorsPage />} />
          <Route path="/recommended/trips" element={<TripsPage />} />
          <Route path="/trip/:id" element={<TripDetailPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
          <Route path="/age-suitability" element={<AgeSuitabilityPage />} />
          <Route path="/app-accessibility" element={<AppAccessibilityPage />} />
          <Route path="/dsa-labels" element={<DSALabelsPage />} />
          <Route path="/roadmap" element={<RoadmapPage />} />
          <Route path="/press-release" element={<PressReleasePage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
